var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDollarCoins(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Dollar Coins",
    clipPath: "url(#clip0_58057_19654)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M14.136 10.1701C14.693 9.29567 15.0304 8.26772 15.0704 7.16387C15.073 7.09029 15.0744 7.01638 15.0744 6.94214C15.0744 3.61931 12.3807 0.925619 9.05786 0.925619C7.87006 0.925619 6.76265 1.26983 5.8299 1.86397C5.32107 1.89273 5.00615 1.28142 5.44093 1.01552C5.45412 1.00746 5.46733 0.99944 5.48057 0.991463C5.50006 0.979721 5.51959 0.968072 5.53921 0.956516C6.56475 0.352365 7.75912 0.00423938 9.03453 3.7075e-05L9.04185 1.85375e-05L9.05786 0C12.8919 0 16 3.10809 16 6.94214C16 7.00444 15.9992 7.06659 15.9975 7.12851L15.9969 7.15101C15.9624 8.31905 15.6394 9.41465 15.0966 10.369C15.0791 10.3997 15.0614 10.4303 15.0435 10.4608C15.0241 10.4937 15.0044 10.5265 14.9845 10.5591C14.7186 10.9939 14.1073 10.679 14.136 10.1701Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.25737 8.22227C8.0745 7.70483 7.58107 7.33333 7 7.33333C7 7.14924 6.85076 7 6.66667 7C6.48257 7 6.33333 7.14924 6.33333 7.33333C5.59697 7.33333 5 7.9303 5 8.66667C5 9.40303 5.59697 10 6.33333 10V11.3333C6.04357 11.3333 5.7962 11.1483 5.7045 10.8889C5.64317 10.7153 5.45273 10.6244 5.27917 10.6857C5.10557 10.7471 5.0146 10.9375 5.07597 11.1111C5.25883 11.6285 5.75227 12 6.33333 12C6.33333 12.1841 6.48257 12.3333 6.66667 12.3333C6.85076 12.3333 7 12.1841 7 12C7.73637 12 8.33333 11.403 8.33333 10.6667C8.33333 9.9303 7.73637 9.33333 7 9.33333V8C7.28977 8 7.53713 8.18503 7.62883 8.4444C7.69017 8.618 7.8806 8.70897 8.05417 8.6476C8.22777 8.58627 8.31873 8.39583 8.25737 8.22227ZM6.33333 8C5.96513 8 5.66667 8.29847 5.66667 8.66667C5.66667 9.03487 5.96513 9.33333 6.33333 9.33333V8ZM7 11.3333C7.3682 11.3333 7.66667 11.0349 7.66667 10.6667C7.66667 10.2985 7.3682 10 7 10V11.3333Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13 9.5C13 13.0899 10.0899 16 6.5 16C2.91014 16 0 13.0899 0 9.5C0 5.91014 2.91014 3 6.5 3C10.0899 3 13 5.91014 13 9.5ZM12.1333 9.5C12.1333 12.6112 9.6112 15.1333 6.5 15.1333C3.3888 15.1333 0.866667 12.6112 0.866667 9.5C0.866667 6.3888 3.3888 3.86667 6.5 3.86667C9.6112 3.86667 12.1333 6.3888 12.1333 9.5Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_58057_19654"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDollarCoins);
export default __webpack_public_path__ + "static/media/Dollar Coins.0d5931f793128bebd48365db7d16e760.svg";
export { ForwardRef as ReactComponent };